import moment from 'moment-timezone'

/**
 * Formats a given date-time string into a specified time zone with a custom time zone abbreviation.
 *
 * @param {string} inputTime - The date-time string to be formatted (e.g., "2023-03-09T11:30:00.000+00:00").
 * @param {string} inputTimeZone - The target time zone identifier (e.g., "America/New_York").
 * @param {string} inputTimeZoneAbbr - The abbreviation of the target time zone (e.g., "EST").
 * @returns {string} - The formatted date-time string in the format "(Patient: MMMM DD YYYY, hh:mm A [inputTimeZoneAbbr])".
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function formatPatientTime(inputTime, inputTimeZone, inputTimeZoneAbbr) {
  const formattedDateTime = moment(inputTime).tz(inputTimeZone).format(`MMM DD YYYY, h:mma [${inputTimeZoneAbbr}]`)

  return `(Patient: ${formattedDateTime})`
}
